import { render, staticRenderFns } from "./SpinnerView.vue?vue&type=template&id=48f73f7a&scoped=true&"
import script from "./SpinnerView.vue?vue&type=script&lang=js&"
export * from "./SpinnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f73f7a",
  null
  
)

export default component.exports